/******************************************************************
 * Archivo : client/src/components/Admin/surveys/AllSurveys/index.js
 * Proyecto: CB30
 ******************************************************************/

import React from "react";
import { graphql } from "react-apollo";
import { Link } from "react-router-dom";
import _ from "lodash";

// Query
import query from "../../../queries/fetchAllSurveys";

const renderUsers = surveys => {

  return _.map(surveys, survey => (

    <tr key={survey.id}>

      <th scope="row">
        <Link to={`/admin/encuesta/editar/${survey.id}`}>
          {survey.titulo}
        </Link>
      </th>

      <td>{survey.descripcion}</td>

    </tr>

  ));

};

const AllSurveys = props => {

  if (props.data.loading) {
    return <div className="loader">Loading...</div>;
  }

  if (!props.data.surveys) {
    return null;
  }

  return (

    <div className="container">

      <h1>Encuestas</h1>

      <table className="table table-striped">

        <thead>

          <tr>
            <th>Título</th>
            <th>Descripción</th>
            
          </tr>

        </thead>

        <tbody>

          {renderUsers(props.data.surveys)}

        </tbody>

      </table>

    </div>

  );

};

export default graphql(query)(AllSurveys);


// WEBPACK FOOTER //
// ./src/components/Admin/surveys/AllSurveys.js